import React from 'react';
import { AutoComplete as AutoCompleteAntd } from 'antd';
import { Body4Light, Input } from '@/ui';
import { COLORS } from '@/utils/static';
import styled from 'styled-components';
import { Label } from '@/components';
import { getLocalizedText } from '@/utils/helpers';
import { useTranslation } from 'react-i18next';

export const AutoComplete = ({
  label,
  required,
  tooltip,
  tooltip_RU,
  tooltip_LV,
  items,
  value,
  onChange,
  onSelect,
  error,
  disabled,
  ...props
}) => {
  const { i18n } = useTranslation();
  return (
    <div>
      {label && (
        <Label label={label} required={required} tooltip={tooltip ? getLocalizedText({
          tooltip: tooltip,
          tooltip_RU: tooltip_RU,
          tooltip_LV: tooltip_LV,
        }, 'tooltip', i18n) : null}>
          {/* {label} */}
          {/* {required && <Text color={COLORS.aragonBlue}>&nbsp;*</Text>} */}
          <RelativeBlock>
            {!disabled && (
              <AutoCompleteAntd
                options={items
                  ? items.map((item) => ({
                    label: item,
                    value: item
                  }))
                  : []}
                style={{ width: 200 }}
                onSelect={onSelect || onChange}
                {...props}
              />
            )}
            {disabled && <Input value={value} disabled={disabled} onChange={onChange} {...props} />}


            {error && (
              <Error>
                <Body4Light $color={COLORS.greyMedium}>{error}</Body4Light>
              </Error>
            )}
          </RelativeBlock>
        </Label>
      )}
    </div>
  );
};

const RelativeBlock = styled.div`
  position: relative;
`;

const Error = styled.div`
  position: absolute;
  text-align: left;
  bottom: calc(50% + 8px + 9px);
  right: 0;
  min-width: 167px;
  padding: 8px;
  background: ${COLORS.darkBabyBlue};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 3px;

  :after {
    content: '';
    position: absolute;
    right: 12px;
    bottom: -3px;
    width: 8px;
    height: 8px;
    background: ${COLORS.darkBabyBlue};
    border-radius: 2px;
    transform: rotate(45deg) skew(10deg, 10deg);
    box-shadow: 3px 3px 5px rgb(0 0 0 / 12%);
  }
`;
